import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect } from "react";
import classnames from "classnames";
import numeral from "numeral";
import SelectRange from "./SelectRange";
import HorizontalRange from "./HorizontalRange";
import "./Range.scss";
export var Range = function Range(a) {
  var b = a.name,
      c = a.label,
      d = a.from,
      e = a.to,
      f = a.step,
      g = void 0 === f ? 1 : f,
      h = a.onChange,
      i = a.value,
      j = a.currency,
      k = a.suffix,
      l = a.minOptionLabel,
      m = a.maxOptionLabel,
      n = _objectWithoutProperties(a, ["name", "label", "from", "to", "step", "onChange", "value", "currency", "suffix", "minOptionLabel", "maxOptionLabel"]),
      o = useState([]),
      p = _slicedToArray(o, 2),
      q = p[0],
      r = p[1];

  b || (b = c.toLowerCase());

  var s = function s(a, c) {
    "function" == typeof h && h({
      name: b,
      value: a
    }, c);
  };

  if (useEffect(function () {
    // initialize all the options
    if (!q.length) {
      for (var a = [], b = d; b <= e; b += g) {
        var c = 1e6 <= b ? "($0.00a)" : "($0a)",
            f = j ? numeral(b).format("string" == typeof j ? j : c) : b;
        a.push({
          name: f,
          value: b
        });
      }

      r(a);
    }
  }, [j, d, q.length, g, e]), !q.length) return null; // @NOTE if the options length is greater than 7
  // it won't look nice if we show as horizontal
  // so in that case we show 2 selects

  var t = 7 < q.length;
  i && "object" != typeof i && (i = [i]), i || t || (i = [d, e]); // range is an array which contains [min, max]

  var u = Object.assign(i || [], []),
      v = classnames("range", n.className, {
    "range--checkbox": !t,
    "range--select": t
  });
  return /*#__PURE__*/React.createElement("div", {
    className: v
  }, t ? /*#__PURE__*/React.createElement(SelectRange, {
    name: b,
    options: q,
    onChange: s,
    minOptionLabel: l,
    maxOptionLabel: m,
    value: u,
    step: g,
    suffix: k
  }) : /*#__PURE__*/React.createElement(HorizontalRange, {
    name: b,
    options: q,
    onChange: s,
    value: u
  }));
};
export var UncontrolledRange = function UncontrolledRange(a) {
  var b = useState(),
      c = _slicedToArray(b, 2),
      d = c[0],
      e = c[1];

  return /*#__PURE__*/React.createElement(Range, Object.assign({}, a, {
    value: d,
    onChange: function onChange(a) {
      var b = a.value;
      return e(b);
    }
  }));
};
export default Range;